define('modules/emblue/view',['require','exports','module','views/BaseView','env','ldsh!./template'],function (require, exports, module) {
  "use strict";

  var BaseView = require("views/BaseView"),
    Config = require("env");

  var Layout = BaseView.extend({
    template: require("ldsh!./template"),
    migrationStatus: false,
    returnUrl: false,
    events: {
      "click #goToBack": "goToBack",
    },

    beforeRender: function () {},

    initialize: function (options) {
      this.migrationStatus = this.options.migrationStatus;
    },

    serialize: function () {
      return { tab: this.options.tab, migrationStatus: this.migrationStatus };
    },
    goToBack: function (event) {
      event.preventDefault();
      event.stopPropagation();
      window.location = this.returnUrl;
    },
  });

  module.exports = Layout;
});

